/**
 * Module errors.
 *
 * @module
 */
/** Account has no capabilities (burn/mint). */
export const ENO_CAPABILITIES = {
  code: 1,
  name: "ENO_CAPABILITIES",
  doc: "Account has no capabilities (burn/mint).",
} as const;
